import T from "@/components/forms/TextField.module.css";

import { WButton } from "@/components/button/WButton.tsx";
import { FieldButtonGroup } from "@/components/forms/FieldButtonGroup.tsx";
import { FormSubmitButton } from "@/components/forms/FormSubmitButton.tsx";
import { WHookForm } from "@/components/forms/WHookForm.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { addServiceWhitelistAddressMutation, type ManagedServiceLoc } from "@/modules/services/servicesQuery.ts";
import { Trans, useLingui } from "@lingui/react/macro";
import type { ServiceWhitelistEntryBody } from "@warrenio/api-spec/spec.oats.gen";
import { FieldError, Input, TextField } from "react-aria-components";
import { useForm } from "react-hook-form";

export interface AddIpFormProps {
    obj: ManagedServiceLoc;
    onClose: () => void;
}

export function AddIpForm({ obj, onClose }: AddIpFormProps) {
    const { t } = useLingui();
    const mutation = useStandardMutation(addServiceWhitelistAddressMutation);

    /// Form
    const form = useForm<ServiceWhitelistEntryBody>({});
    const { register, getValues } = form;

    return (
        <WHookForm
            form={form}
            onSubmit={async () => {
                await mutation.mutateAsync({ uuid: obj.uuid, body: { ip_address: getValues("ip_address") } });
                onClose();
            }}
        >
            <TextField isRequired type="text" aria-label="IP address" className={T.TextField}>
                <FieldButtonGroup>
                    <Input
                        className={T.Input}
                        placeholder={t`IP address`}
                        autoFocus={true}
                        {...register("ip_address")}
                    />
                    <FormSubmitButton icon="jp-icon-add">
                        <Trans>Add</Trans>
                    </FormSubmitButton>
                    <WButton action={onClose}>
                        <Trans>Close</Trans>
                    </WButton>
                </FieldButtonGroup>
                <FieldError />
            </TextField>
        </WHookForm>
    );
}
